import { Bell, Sparkle } from "@phosphor-icons/react";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      {/* Left: vibrant panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden border-r-2 border-black"
        style={{
          background: "linear-gradient(135deg, #4361EE 0%, #FF6B6B 50%, #FFD166 100%)",
        }}>
        <div className="bg-grid absolute inset-0 opacity-30" />
        <div className="relative z-10 flex items-center gap-3">
          <img src="/icons/icon-192.png?v=4" alt="DueMate" className="w-12 h-12 rounded-md border-2 border-black shadow-[4px_4px_0px_#111111] object-cover" />
          <span className="font-heading text-2xl font-black text-white">DueMate</span>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="font-heading text-5xl xl:text-6xl font-black text-white leading-[1.05] tracking-tighter">
            Never miss<br/>a follow-up<br/>service again.
          </h1>
          <p className="text-white/95 text-lg font-semibold max-w-md">
            Track customer service intervals across 20+ business types and send timely WhatsApp reminders.
          </p>
          <div className="flex gap-3 flex-wrap">
            {["RO Service", "Pet Grooming", "Car Garage", "Dental", "AC Service"].map((t) => (
              <span key={t} className="bg-white text-black font-bold text-xs px-3 py-1.5 border-2 border-black rounded-full">
                {t}
              </span>
            ))}
          </div>
        </div>
        <div className="relative z-10 text-white/90 text-sm font-semibold">
          Built for inverter dealers, vets, salons, garages & 20+ more.
        </div>
      </div>

      {/* Right: login card */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md nb-card p-8 sm:p-10 anim-fade-up">
          <div className="flex items-center gap-2 mb-2">
            <Sparkle size={22} weight="fill" className="text-[#4361EE]" />
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#4A4A4A]">Sign in to continue</span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-black tracking-tight mb-3">Welcome back</h2>
          <p className="text-[#4A4A4A] font-medium mb-8">
            Sign in with Google to manage your customers and reminders.
          </p>

          <button
            data-testid="google-login-button"
            onClick={handleGoogleLogin}
            className="nb-btn w-full bg-white text-black px-5 py-4 flex items-center justify-center gap-3"
          >
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            <span className="font-bold">Continue with Google</span>
          </button>

          <div className="mt-8 pt-6 border-t-2 border-dashed border-black/15">
            <p className="text-xs text-[#4A4A4A] font-semibold">
              By continuing you agree to our terms. We only store your email, name & profile picture.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
